
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';

export default defineComponent({
  name: 'AppSignIn',
  setup() {
    const router = useRouter();
    const store = useStore();

    const signInWithGoogle = async () => {
      await store.dispatch.auth.signIn();

      if (await store.dispatch.groups.getGroupId()) {
        await router.push('/bids');
      } else {
        await router.push('/group-create-or-join');
      }
    };

    return {
      signInWithGoogle
    };
  }
});
